import * as i0 from '@angular/core';
import { Directive, NgModule, Component, ViewEncapsulation, Input, HostBinding, Optional } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i1$1 from '@angular/material/list';
import { OneBadgeModule } from '@one/angular-kit/indicator';

class CardDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'one-card');
    }
}
CardDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: CardDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
CardDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: CardDirective, selector: "mat-card[oneCard]", providers: [], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: CardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-card[oneCard]',
                    providers: []
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class OneCardModule {
}
OneCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneCardModule, declarations: [CardDirective], imports: [CommonModule], exports: [CardDirective] });
OneCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneCardModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CardDirective],
                    exports: [CardDirective],
                    imports: [CommonModule]
                }]
        }] });

class OneExpandableComponent {
    constructor() {
        this.appearance = 'squared';
        this.expanded = false;
        this.disabled = false;
    }
    toggleExpand() {
        if (!this.disabled) {
            this.expanded = !this.expanded;
        }
    }
}
OneExpandableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneExpandableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneExpandableComponent, selector: "one-expandable", inputs: { appearance: "appearance", expanded: "expanded", disabled: "disabled" }, host: { properties: { "class.disabledExpandable": "this.disabled" } }, ngImport: i0, template: "<div class=\"one-expandable-header {{appearance}}\">\n  <button *ngIf=\"appearance === 'squared'\" mat-stroked-button one-secondary-button (click)=\"toggleExpand()\" [disabled]=\"disabled\">\n    <mat-icon>{{expanded ? 'collapse' : 'expand'}}</mat-icon>\n  </button>\n  <button *ngIf=\"appearance === 'rounded'\" mat-stroked-button one-button-rounded one-secondary-button (click)=\"toggleExpand()\" [disabled]=\"disabled\">\n    <mat-icon>{{expanded ? 'collapse' : 'expand'}}</mat-icon>\n  </button>\n  <ng-content select=\"[one-expandable-title]\"></ng-content>\n</div>\n<ng-content *ngIf=\"expanded\" select=\"[one-expandable-content]\"></ng-content>\n", styles: ["one-expandable .one-expandable-header [one-expandable-title]{display:inline;line-height:21px;font-weight:500;font-size:16px}one-expandable .one-expandable-header button[mat-stroked-button]{min-width:0;margin-right:16px;padding:0 5px}one-expandable [one-expandable-content]{margin-left:52px}one-expandable [one-expandable-content] p{margin:6px 6px 6px 0;line-height:21px;font-size:16px}\n"], components: [{ type: i1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-expandable',
                    templateUrl: './expandable.component.html',
                    styleUrls: ['./expandable.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { appearance: [{
                type: Input
            }], expanded: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.disabledExpandable']
            }, {
                type: Input
            }] } });

class OneExpandableModule {
}
OneExpandableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneExpandableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableModule, declarations: [OneExpandableComponent], imports: [CommonModule, MatIconModule, MatButtonModule], exports: [OneExpandableComponent] });
OneExpandableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableModule, imports: [[CommonModule, MatIconModule, MatButtonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneExpandableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneExpandableComponent],
                    imports: [CommonModule, MatIconModule, MatButtonModule],
                    exports: [OneExpandableComponent]
                }]
        }] });

var OneListTypes;
(function (OneListTypes) {
    OneListTypes["dense"] = "dense";
    OneListTypes["compact"] = "compact";
    OneListTypes["default"] = "default";
    OneListTypes["expanded"] = "expanded";
    OneListTypes["big"] = "big";
})(OneListTypes || (OneListTypes = {}));
const ONELIST_CSS_CLASS = 'one-list';
class ListDirective {
    constructor(renderer, el, matList, matNavList, matSelectionList) {
        this.renderer = renderer;
        this.el = el;
        this.matList = matList;
        this.matNavList = matNavList;
        this.matSelectionList = matSelectionList;
        this.oneList = OneListTypes.default;
    }
    ngOnInit() {
        const listTypeIsEmpty = this.oneList && this.oneList.length === 0;
        let currentListType = this.oneList;
        if (!currentListType || listTypeIsEmpty) {
            currentListType = OneListTypes.default;
        }
        this.applyOneListType(currentListType, null, this.el.nativeElement);
    }
    ngOnChanges(changes) {
        const previousListType = changes.oneList.previousValue;
        const listElement = this.el.nativeElement;
        let currentListType = changes.oneList.currentValue;
        const listTypeIsEmpty = currentListType && currentListType.length === 0;
        if (!currentListType || listTypeIsEmpty) {
            currentListType = OneListTypes.default;
        }
        this.clearCSSTypeClasses();
        this.applyOneListType(currentListType, previousListType, listElement);
    }
    getClassTemplate(type) {
        return `${ONELIST_CSS_CLASS}-${type}`;
    }
    clearCSSTypeClasses() {
        const listTypes = ['dense', 'compact', 'default', 'expanded', 'big'];
        const listElement = this.el.nativeElement;
        listTypes.forEach((type) => this.renderer.removeClass(listElement, this.getClassTemplate(type)));
    }
    applyOneListType(currentListType, previousListType, nativeEl) {
        this.renderer.addClass(nativeEl, this.getClassTemplate(currentListType));
        if (previousListType === OneListTypes.dense && currentListType !== OneListTypes.dense) {
            this.renderer.removeAttribute(nativeEl, 'dense');
        }
        else if (currentListType === OneListTypes.dense) {
            this.renderer.setAttribute(nativeEl, 'dense', '');
        }
    }
}
ListDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ListDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1$1.MatList, optional: true }, { token: i1$1.MatNavList, optional: true }, { token: i1$1.MatSelectionList, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
ListDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: ListDirective, selector: "mat-list[oneList] , mat-nav-list[oneList], mat-selection-list[oneList], mat-action-list[oneList]", inputs: { oneList: "oneList" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ListDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-list[oneList] , mat-nav-list[oneList], mat-selection-list[oneList], mat-action-list[oneList]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1$1.MatList, decorators: [{
                    type: Optional
                }] }, { type: i1$1.MatNavList, decorators: [{
                    type: Optional
                }] }, { type: i1$1.MatSelectionList, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { oneList: [{
                type: Input
            }] } });

class OneListBadgesComponent {
    constructor() { }
    ngOnInit() { }
}
OneListBadgesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListBadgesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneListBadgesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneListBadgesComponent, selector: "one-list-badges", ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["one-list-badges{position:absolute;top:14px;right:12px;display:flex;flex-direction:row}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListBadgesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-list-badges',
                    templateUrl: './list-badges.component.html',
                    styleUrls: ['./list-badges.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return []; } });

class OneListModule {
}
OneListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListModule, declarations: [ListDirective, OneListBadgesComponent], imports: [CommonModule, OneBadgeModule], exports: [ListDirective, OneListBadgesComponent] });
OneListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListModule, imports: [[CommonModule, OneBadgeModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ListDirective, OneListBadgesComponent],
                    exports: [ListDirective, OneListBadgesComponent],
                    imports: [CommonModule, OneBadgeModule]
                }]
        }] });

/*
 * Public API Surface of layout
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardDirective, ListDirective, OneCardModule, OneExpandableComponent, OneExpandableModule, OneListBadgesComponent, OneListModule };
